import { MessageModel, FileMessageModel } from '@/models/message.model'
import { createAction, createAsyncAction } from 'typesafe-actions'

export type CreateMessageRequestParam = {
  onSuccess?: () => void
  onFailure?: (error: unknown) => void
  typeFile?: 'audio' | 'text' | 'attachment' | 'sticker' | 'messageTemplate' | 'contact' | 'location' | null
  ownerId: string
  campanhaId: string
  isOfficial?: boolean
  token: string
  phoneNumberId: string
  message: { files?: Array<Partial<FileMessageModel>> } & Pick<
    MessageModel,
    | 'isQuickReply'
    | 'location'
    | 'isOfficial'
    | 'messageTypeSent'
    | 'templateMessageId'
    | 'phone'
    | 'connectedPhone'
    | 'senderId'
    | 'senderNumber'
    | 'receiverNumber'
    | 'chatId'
    | 'messageText'
    | 'operator'
    | 'ownerId'
    | 'campanhaId'
    | 'stickerUrl'
    | 'typeFile'
    | 'caption'
    | 'replyMessage'
    | 'editMessage'
    | 'contactsMessage'
  >
}
export const createMessageAsync = createAsyncAction(
  '@message/CREATE_MESSAGE_REQUEST',
  '@message/CREATE_MESSAGE_SUCCESS',
  '@message/CREATE_MESSAGE_FAILURE'
)<CreateMessageRequestParam, void, Error>()

export const fetchMoreMessagesAsync = createAsyncAction(
  '@message/FETCH_MORE_MESSAGES_REQUEST',
  '',
  '@message/FETCH_MORE_MESSAGES_FAILURE'
)<{ chatId: string; lastMessage?: MessageModel; ownerId: string }, null, Error>()

export const setHasMoreMessages = createAction('@message/SET_HAS_MORE-MESSAGES')<{ state: boolean }>()

export * from './handles'
